import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LlttfInvitationService } from 'src/app/services/llttf-invitation.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-llttf-check-eligibility',
    templateUrl: './llttf-check-eligibility.component.html',
    styleUrls: ['./llttf-check-eligibility.component.scss'],
    standalone: false
})
export class LlttfCheckEligibilityComponent {

  verificationGuid:string=''
  constructor(private route:ActivatedRoute,private _llttfservice:LlttfInvitationService,private router:Router,private _toastService:ToastService){}
  ngOnInit(): void 
  {
    this.route.params.subscribe(param=>{
      this.verificationGuid=param['verificationguid'] 
      this._llttfservice.confirmEligibility(this.verificationGuid).subscribe({
        next:(res)=>
          {
            if(!res.status)
            {
              this._toastService.showErrorMessage(res.message)
            }
            else{
            this._toastService.showMessage(res.message)
            }
            this.router.navigateByUrl(res.redirectTo);
          }
      })
    })
  }

}
